module.exports = __webpack_public_path__ + "static/media/zoneAdminApprovedIcon.b0eb04d1.svg";